import React, { useState } from 'react';

import { ProfileQL } from '../../../models/Profile';
import { BaseReact } from '../../../base.model';
import { useQuery, useSubscription } from '@apollo/client';

import SectionTitleBar from '../../components/titlebar';
import { ReportJob } from '../../../models/Report';

import { graphqlSchema } from '../../../services/graphql.schema';

import './Reporte.list.scss';
import Loading from '../../Animations/loadScreen';
import { ReportProgressSubscription } from '../../../models/Subscriptions';

import moment from 'moment';
import { Link, NavLink } from 'react-router-dom';

interface OrdersReporteProps extends BaseReact {
    currentUser: ProfileQL;
}


function OrdersReportList({ history, location, currentUser }: OrdersReporteProps) {

    const [reportBuildProgress, setReportBuildProgress] = useState<ReportProgressSubscription>(null);

    useSubscription<{ reportBuildProgress: ReportProgressSubscription }>(graphqlSchema.PROFILE.REPORTS.reportBuildProgress, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('reportBuildProgress: ', subscriptionData);
            const reportBuildProgress: ReportProgressSubscription = subscriptionData.data.reportBuildProgress;
            setReportBuildProgress(reportBuildProgress);

        }
    });

    const { loading, data } = useQuery<{ getReportJobs: ReportJob[] }>(graphqlSchema.PROFILE.REPORTS.getReportJobs, {
        fetchPolicy: 'cache-and-network'
    });

    const getReportJobs = data?.getReportJobs;

    const stateLabel = (repProgress: ReportProgressSubscription) => {

        if (!!repProgress.productsProgress) {
            return `Obteniendo productos: ${repProgress.productsProgress.fetched || 0} / ${repProgress.ordersFetchProgress.fetched} hasta ahora`
        }
        if (!!repProgress.billsProgress) {
            return `Obteniendo facturas: ${repProgress.billsProgress.fetched || 0} hasta ahora`
        }
        if (!!repProgress.ordersBindedProgress) {
            return `Procesando pedidos: ${repProgress.ordersBindedProgress.fetched || 0} hasta ahora`
        }
        if (!!repProgress.ordersFetchProgress) {
            return `Obteniendo pedidos: ${repProgress.ordersFetchProgress.fetched || 0} hasta ahora`
        }
    }

    const renderCurrentJob = (activeJob: ReportJob) => {
        if (!activeJob) {
            return ''
        }
        return (
            <div className="currentJob">
                <p>Reporte actualmente generandose</p>
                <div className="card jobDetail">
                    <div>
                        <p>{activeJob.templateIs.name}</p>
                        <p>{moment(new Date(activeJob.startDate)).endOf('day').format('DD MMM YYYY')} a {moment(new Date(activeJob.endDate)).endOf('day').format('DD MMM YYYY')}</p>
                    </div>
                    <div>
                        <p>
                            Estado actual
                        </p>
                        <p className="stage">
                            {activeJob.hasStarted === false ? `En cola para generarse`: (reportBuildProgress ? stateLabel(reportBuildProgress) : 'Terminado')}
                        </p>
                    </div>
                    <Loading
                        svgHeight={'34px'}
                        svgWidth={'34px'}
                        display={true}
                        relativePos={true}
                    />
                </div>
            </div>
        )
    }

    const renderPastJob = (pastJobs: ReportJob[]) => {
        return (
            <div className={`previousJob`}>
                <p>Reportes anteriores</p>
                {
                    pastJobs.map(job => (
                        <div className="card jobDetail" key={job._id}>
                            <div>
                                <p>{job.templateIs.name || 'SIN NOMBRE'}</p>
                                <p>{moment(new Date(job.startDate)).endOf('day').format('DD MMM YYYY')} a {moment(new Date(job.endDate)).endOf('day').format('DD MMM YYYY')}</p>
                            </div>
                            <div className='_created'>
                                <p className={job.hasStarted === false ? 'queued' : ''}>
                                    {job.hasStarted ? 'Creado' : (job.hasStarted === false ? 'En cola' : 'Creado')}
                                </p>
                                <p>
                                    {moment(new Date(job.createdAt)).endOf('day').format('DD MMM YYYY')}
                                </p>
                            </div>
                            <Link to={`/ordenes/report/generation/${job._id}`}>
                                Ver
                            </Link>
                        </div>
                    ))
                }
            </div>
        )
    }

    const renderJobs = () => {
        if (loading) {
            return ''
        }
        if (!loading && !getReportJobs.length) {
            return (
                <div className="_isEmpty">
                    <h2>
                        Todavía no has generado un reporte
                    </h2>
                    <p>
                        Crea tu primer reporte y consúltalo cuando termine de generarse
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px">
                        <path d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z" />
                    </svg>
                </div>
            )
        }
        return (
            <div className="listArrange">
                {renderCurrentJob(getReportJobs.find(j => j.working || (j.hasStarted === false)))}
                {renderPastJob(getReportJobs.filter(j => !j.working && (j.hasStarted !== false)).sort((a, b) => b.createdAt - a.createdAt))}
            </div>
        )
    }

    return (
        <div id="OrdenesReporteList">
            <SectionTitleBar currentUser={currentUser} title="Lista de reportes generados" />
            <div className="reporteListContent">
                <div className='goToNew'>
                    <div className="toBulk">
                        <NavLink to="/ordenes/report/generate">
                            <span>
                                Crear nuevo reporte
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path xmlns="http://www.w3.org/2000/svg" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z" />
                            </svg>
                        </NavLink>
                    </div>
                </div>
                {loading ? <Loading
                    svgHeight={'84px'}
                    svgWidth={'84px'}
                    display={true}
                    relativePos={false}
                /> : ''}
                {
                    renderJobs()
                }
            </div>
        </div >
    )
}

export default OrdersReportList;